import { GroupRestrictedSpotType } from 'src/Shared/enums/group-restricted-spot-type.enum';
import { resolveSupportPageUrl } from 'src/Shared/utils/resolveSupportPageUrl';
import { getContactSupportUrl } from 'src/Foundation/Design/app';
import { getLocalePrefix } from 'src/Shared/utils/get-locale-prefix';
var ContactSupportSectionController = (function () {
    function ContactSupportSectionController($scope, productContextService, dynamicPagesSpotsDisplayOptionsService, groupRestrictedSpotType) {
        if (groupRestrictedSpotType === void 0) { groupRestrictedSpotType = GroupRestrictedSpotType.ContactsSupport; }
        this.$scope = $scope;
        this.productContextService = productContextService;
        this.dynamicPagesSpotsDisplayOptionsService = dynamicPagesSpotsDisplayOptionsService;
        this.groupRestrictedSpotType = groupRestrictedSpotType;
    }
    ContactSupportSectionController.prototype.$onInit = function () {
        var _this = this;
        this.$scope.contactSupportUrl = '';
        var localePrefix = getLocalePrefix();
        this.productContextService
            .subscribe()
            .then(null, null, function (group) {
            _this.$scope.contactSupportUrl = '';
            if (!group) {
                return;
            }
            resolveSupportPageUrl(group);
            _this.dynamicPagesSpotsDisplayOptionsService
                .getSpotUrlOrEmpty(group.supportPageUrl, _this.groupRestrictedSpotType, _this.$scope, group.groupId, getContactSupportUrl(group))
                .then(function (url) {
                _this.$scope.contactSupportUrl =
                    (localePrefix && !url.startsWith(localePrefix)) ?
                        "" + localePrefix + url :
                        url;
            });
        });
    };
    ContactSupportSectionController.$inject = ['$scope', 'productContextService', 'dynamicPagesSpotsDisplayOptionsService'];
    return ContactSupportSectionController;
}());
export { ContactSupportSectionController };
